import React, { useContext, useEffect } from "react";
import "../../Styles/globalStyle.css";
import "./Organigram.css";
import AccordionList from "../../AccordionList/AccordionList";
import DiagramList from "../../DiagramList/DiagramList";
import DiagramItem from "../../DiagramItem/DiagramItem";
import { useHistory } from "react-router-dom";
import uuid from "react-native-uuid";
import { store } from "../../../store.js";
import useSetProcessOrganigram from "../../../Hooks/useSetProcessOrganigram.js";

export default function Organigram(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const history = useHistory();
  const setProcessOrganigram = useSetProcessOrganigram();

  useEffect(() => {
    if (props.settings) {
      var organigramItems = JSON.parse(JSON.stringify(globalState.state.organigramItems)) 
      organigramItems.lists.Steps = props.settings.Profil.details.map(detail => 
        {return {id : detail.id, globalId:detail.globalId, item:detail.key.value }} )
      organigramItems.lists.Decisions = []
      const step = organigramItems.lists.Steps[0]
      
      if (step) {
        var template = {
          id: 1,
          globalId:uuid.v4(),
          order: 1,
          isExpanded: true,
          isChecked: true,
          policy: { read: true, edit: true, delete: true },
          menu: "menuSteps",
          items: {
          width: { 1: "100%" },
          data: [
            {
              id: 1,
              globalId:uuid.v4(),
              item: { id: step.id, globalId:step.globalId, item: step.item },
              order: 1,
              isChecked: true,
              list: "Steps",
            },
          ],
        },
        childs: [],
        }
        if (props.settings.Chart.data.length > 0) {
          const chart = JSON.parse(JSON.stringify(props.settings.Chart))
          organigramItems.lists.currentMaxId = chart.currentMaxId
          organigramItems.data = chart.data
        }
        else {
          organigramItems.lists.currentMaxId = 1
          organigramItems.data = [template]
        }
        
        
      } else {
        organigramItems.lists.currentMaxId = 1
        organigramItems.data = []
      }
      dispatch({
        type: "SET_ORGANIGRAM_SETTINGS",
        payload: organigramItems,
      });
    }   
  }, []);

  const getAccordionsItems = (accordionsItems) => {
    
    accordionsItems.data.sort((a,b) => a.order > b.order ? 1 : -1)
    return accordionsItems
  }
  
  const CallSettingsStep  = (param) => {
   
    /*dispatch({
      type: "SET_STEP",
      payload: {profils: getProfils(), decisions:getDecisions()},
    });*/
    
    setProcessOrganigram(props.organigram, props.process)
    history.push({pathname: '/profilUser', search: `?organigramId=${props.settings.id}&profilGlobalId=${param.itemId}`})
  }

  return (
    <div className="middleFormContainer">
      <div className="leftOrganigramContainer">
        <div className="organigramContainer">
          <AccordionList
            accordionsItems={getAccordionsItems(JSON.parse(JSON.stringify(globalState.state.organigramItems)))}
            type="CLICK_ORGANIGRAM_MENU"
            withCondition={false}
            CallSettingsStep = {(paremeters) => CallSettingsStep(paremeters)}
          />
        </div>
       
      </div>

      <div className="rightOrganigramContainer">
        <DiagramList
          diagramItems={globalState.state.organigramItems}
          withCondition={false}
        />
      </div>
    </div>
  );

  /*

 <input
          style={{ marginLeft: "40px" }}
          type="button"
          className="button"
          value="Enregistrer"
        />

  */
}
